<table>
    <thead>
        <th class="subtable string">{{'global.pais' | translate}}</th>
        <th class="subtable string">{{'mantenimientoEtiquetadores.denominaciones.denominacion' | translate}}</th>
        <th class="subtable string" *ngIf="this.role === 'Administrador'">{{'mantenimientoEtiquetadores.denominaciones.etiquetasCaja' | translate}}</th>
        <th class="subtable string" *ngIf="this.role === 'Administrador'">{{'mantenimientoEtiquetadores.denominaciones.etiquetasPallet' | translate}}</th>
        <th class="subtable" *ngIf="this.role === 'Administrador' || this.claims.includes('ETQ_PD_Upd_ImpAut')">{{'mantenimientoEtiquetadores.denominaciones.autorizado' | translate}}</th>
        <th class="subtable" *ngIf="this.role === 'Administrador' || this.claims.includes('ETQ_PD_Upd_ReimpAut')">{{'mantenimientoEtiquetadores.denominaciones.reimp' | translate}}</th>
        <th class="subtable action">
            <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" app-click-stop-propagation
            (click)="newPaisDenominacion()" title="{{'mantenimientoEtiquetadores.denominaciones.tituloNew' | translate}}"></i>
        </th>
    </thead>
    <tbody>
        <app-etq-denominacion-new-edit class="component-in-row" *ngIf="new" [editable]="true" [etiquetadorId]="etiquetadorId" (close)="new=$event"
        (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
        (pushMessage)="pushMessage.emit($event)"
        [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja"
        [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet"></app-etq-denominacion-new-edit>
        <app-etq-denominacion-new-edit class="component-in-row" *ngFor="let denominacion of denominacionesList" [etiquetadorId]="etiquetadorId" [denominacion]="denominacion" [editable]="denominacion === denominacionEditable" (close)="new=$event"
        (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
        (pushMessage)="pushMessage.emit($event)"
        [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja"
        [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet"
        [grupoEtiquetasCaja]="getGruposEtiqueta(denominacion, 1)"
        [grupoEtiquetasPallet]="getGruposEtiqueta(denominacion, 2)"></app-etq-denominacion-new-edit>
    </tbody>
    <tfoot *ngIf="denominacionesList && denominacionesList.length < 1 && !new">
        <tr>
          <td colspan="7">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>
